import React from 'react'
import {
  Code,
  Heading,
  List,
  PageHeading,
  Text,
} from '../../../shared/typography'
import { Box, StackView } from '@planningcenter/tapestry-react'
import Image from '../../../shared/image'
import insertion_point_people__list__send_message from '../../../../assets/images/insertion_point_people.list.send_message.png'

const page = () => {
  return (
    <StackView axis="vertical" spacing={2}>
      <PageHeading>Add-ons Insertion Points</PageHeading>

      <Text>
        The following "insertion points" are currently available for your add-on
        to affect the Planning Center user interface:
      </Text>

      <Heading anchored id="people-list-send_message" size={1} level={2}>
        <Code>people.list.send_message</Code>
      </Heading>

      <Text>Opens a modal with your add-on content.</Text>

      <Box>
        <Image
          src={insertion_point_people__list__send_message}
          style={{ width: '512px' }}
        />
      </Box>

      <List>
        <List.Item>
          <Text>
            <Code>args</Code>
          </Text>
          <List>
            <List.Item>
              <Text>
                <Code>listId</Code>: unique ID number of the list
              </Text>
            </List.Item>
            <List.Item>
              <Text>
                <Code>listName</Code>: name or description of list
              </Text>
            </List.Item>
            <List.Item>
              <Text>
                <Code>currentPersonId</Code>: current person (user) ID
              </Text>
            </List.Item>
            <List.Item>
              <Text>
                <Code>currentOrganizationId</Code>: current organization
                (tenant) ID
              </Text>
            </List.Item>
            <List.Item>
              <Text>
                <Code>closeModal</Code>: a function that closes the add-on modal
                when invoked
              </Text>
            </List.Item>
          </List>
        </List.Item>
      </List>

      <Heading
        anchored
        id="people-dashboards-background_checks-new"
        size={1}
        level={2}
      >
        <Code>people.dashboards.background_checks.new</Code>
      </Heading>

      <Text>
        Opens a modal to start a background check from the background check
        dashboard.
      </Text>

      <List>
        <List.Item>
          <Text>
            <Code>args</Code>
          </Text>
          <List>
            <List.Item>
              <Text>
                <Code>currentPersonId</Code>: current person (user) ID
              </Text>
            </List.Item>
            <List.Item>
              <Text>
                <Code>currentOrganizationId</Code>: current organization
                (tenant) ID
              </Text>
            </List.Item>
            <List.Item>
              <Text>
                <Code>closeModal</Code>: a function that closes the add-on modal
                when invoked
              </Text>
            </List.Item>
          </List>
        </List.Item>
      </List>

      <Heading
        anchored
        id="people-profile-background_checks-new"
        size={1}
        level={2}
      >
        <Code>people.profile.background_checks.new</Code>
      </Heading>

      <Text>
        Opens a modal to start a background check from a person's profile page.
      </Text>

      <List>
        <List.Item>
          <Text>
            <Code>args</Code>
          </Text>
          <List>
            <List.Item>
              <Text>
                <Code>personId</Code>: ID of person profile being viewed
              </Text>
            </List.Item>
            <List.Item>
              <Text>
                <Code>currentPersonId</Code>: current person (user) ID
              </Text>
            </List.Item>
            <List.Item>
              <Text>
                <Code>currentOrganizationId</Code>: current organization
                (tenant) ID
              </Text>
            </List.Item>
            <List.Item>
              <Text>
                <Code>closeModal</Code>: a function that closes the add-on modal
                when invoked
              </Text>
            </List.Item>
          </List>
        </List.Item>
      </List>
    </StackView>
  )
}

export default page
